import React from 'react';

import Rioglyph, { type IconType } from '@rio-cloud/rio-uikit/Rioglyph';
import SimpleTooltip from '@rio-cloud/rio-uikit/SimpleTooltip';
import { getFuelIcon, type FuelType } from '@rio-cloud/rio-uikit/fuelTypeUtils';

interface AssetTypeProps {
    assetType: string;
    fuelType?: string | null;
    status?: string | null;
}

export const AssetType = React.memo((props: AssetTypeProps) => {
    const fuelTypeIcon = props.fuelType ? getFuelIcon(props.fuelType.toLowerCase() as FuelType) : undefined;
    const color = props.status === 'active' ? 'text-color-primary' : 'text-color-light';

    return (
        <span className='display-flex'>
            <SimpleTooltip
                placement='right'
                textAlignment='left'
                content={
                    <>
                        <span>asset type: </span>
                        {props.assetType.toLowerCase()}
                        {props.fuelType && (
                            <>
                                <br />
                                <span>fuel type: </span>
                                {props.fuelType.toLowerCase()}
                            </>
                        )}
                        {props.status && (
                            <>
                                <br />
                                <span>status: </span>
                                {props.status.toLowerCase()}
                            </>
                        )}
                    </>
                }
            >
                <span>
                    <Rioglyph
                        size='h3'
                        icon={`rioglyph-${props.assetType.toLowerCase()}` as IconType}
                        iconClassName={color}
                        pairIconClassName={color}
                        pairIcon={fuelTypeIcon}
                    />
                </span>
            </SimpleTooltip>
            <span hidden>{props.assetType.toLowerCase()}</span>
        </span>
    );
});
